import { ILedgerAccount } from '../interfaces/ledger-account.interface';

export type AssetCategoryAccountType = Pick<ILedgerAccount, 'id' | 'code' | 'name' | 'status'>;
